import PropTypes from "prop-types";

import SearchBoxGeneric from "components/SearchBoxGeneric";
import SearchResults from "components/SearchResults";

const withAlgoliaCard = (WrappedComponent) => {
  function WithAlgoliaCard({ loading, initialQueryObject, ...props }) {
    return (
      <SearchBoxGeneric
        loading={loading}
        initialQueryObject={initialQueryObject}
        searchResultsSkeletonSlot={<WrappedComponent loading />}
        resultsSlot={SearchResults}
        resultsSlotProps={{
          WrappedComponent,
          shouldTrackAlgoliaAnalytics: true,
          ...props,
        }}
      />
    );
  }

  WithAlgoliaCard.propTypes = {
    initialQueryObject: PropTypes.shape({}),
    loading: PropTypes.bool,
  };

  return WithAlgoliaCard;
};

export default withAlgoliaCard;
